module.exports = __webpack_public_path__ + "img/suc3.1daf1f1a.png";